const mediaItems = [
  {
    id: 1,
    title: '年度黑料大盘点：今年最炸裂的十大翻车事件',
    views: '128万',
    time: '15:42',
    src: 'https://readdy.ai/api/search-image?query=soft%20focus%20dramatic%20abstract%20warm%20red%20and%20amber%20wave%20patterns%20against%20dark%20background%20modern%20digital%20media%20aesthetic%20cinematic%20bokeh%20effect%20warm%20tone%20editorial%20style&width=800&height=560&seq=media-card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '网红翻车实录：从顶流到凉凉只用了三天',
    views: '96万',
    time: '22:18',
    src: 'https://readdy.ai/api/search-image?query=abstract%20glowing%20geometric%20shapes%20warm%20orange%20and%20deep%20coral%20red%20modern%20digital%20art%20background%20smooth%20gradient%20cinematic%20atmosphere&width=800&height=560&seq=media-card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '综艺名场面：那些被导师偏心毁掉的选手们',
    views: '83万',
    time: '09:55',
    src: 'https://readdy.ai/api/search-image?query=artistic%20composition%20warm%20coral%20light%20streaks%20against%20dark%20backdrop%20abstract%20modern%20editorial%20style%20dramatic%20warm%20tones%20professional%20quality&width=800&height=560&seq=media-card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '品牌塌房全记录：消费者维权路上的血泪史',
    views: '71万',
    time: '18:30',
    src: 'https://readdy.ai/api/search-image?query=abstract%20concentric%20circles%20warm%20amber%20tones%20dark%20background%20pulse%20wave%20pattern%20modern%20digital%20aesthetics%20cinematic%20moody%20lighting&width=800&height=560&seq=media-card-04&orientation=landscape',
  },
];

export default function SectionMedia() {
  return (
    <section id="media" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4 whitespace-nowrap">
              <i className="ri-play-circle-line"></i> 热门视频
            </span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">
              热点视频
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto leading-relaxed">
              精选全网最热八卦解读视频，图文并茂呈现事件全貌
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {mediaItems.map((item) => (
              <div key={item.id} className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer hover:shadow-lg transition-all duration-300">
                {/* Thumbnail */}
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={item.src}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors"></div>
                  {/* Play button */}
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 h-12 flex items-center justify-center bg-background-50/90 rounded-full group-hover:bg-primary-500 transition-colors">
                      <i className="ri-play-fill text-xl text-primary-500 group-hover:text-background-50 transition-colors ml-0.5"></i>
                    </div>
                  </div>
                  {/* Time badge */}
                  <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded text-xs bg-black/60 text-background-50 font-mono">
                    {item.time}
                  </span>
                </div>
                {/* Info */}
                <div className="p-4">
                  <h3 className="font-heading text-sm md:text-base text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className="ri-eye-line"></i>
                    <span>{item.views} 次播放</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}